// common
import TabsView from 'common/components/TabsView';

//screen
import ChangePasswordTab from 'modules/user-info/detail/tabs/ChangePasswordTab';
import UserInfoTab from 'modules/user-info/detail/tabs/UserInfoTab';
import { UserInfoDataProvider } from 'modules/user-info/detail/dataContext';
import { useUserInfoData } from 'modules/user-info/detail/useUserInfoData';

// Inner component that uses the context
const UserInfoDetailContent = () => {
  const { isClient } = useUserInfoData();

  return (
    <TabsView
      tabLabels={isClient ? ['account.userInfo'] : ['account.userInfo', 'account.changePassword']}
      tabContents={isClient ? [<UserInfoTab />] : [<UserInfoTab />, <ChangePasswordTab />]}
    />
  );
};

// Main component that provides the context
const UserInfoDetailPage = () => {
  return (
    <UserInfoDataProvider>
      <UserInfoDetailContent />
    </UserInfoDataProvider>
  );
};

export default UserInfoDetailPage;
